import React from 'react'
import { components, OptionProps } from 'react-select'
import { makeStyles } from '@mui/styles'
import CheckRoundedIcon from '@mui/icons-material/CheckRounded'
import ThemeInterface from '@/theme-interface'

const useStyles = makeStyles((theme: ThemeInterface) => ({
  check: {
    flexShrink: 0,
    width: 20,
    height: 20,
    color: theme.palette.brand.main,
  },
}))

// An option of the checkout's dropdowns (design "Anrede · Auswahl geöffnet"): the selected one carries a tick
// at its end. Passed to SelectInput / CountryInput as `customComponents.Option`.
const BrandSelectOption = (props: OptionProps) => {
  const classes = useStyles()

  return (
    <components.Option {...props}>
      {props.children}
      {props.isSelected && <CheckRoundedIcon className={classes.check} aria-hidden data-qs-id='checkout-select-option-check' />}
    </components.Option>
  )
}

export default BrandSelectOption
